import { render, staticRenderFns } from "./UserSummary.vue?vue&type=template&id=f524b542&scoped=true"
import script from "./UserSummary.vue?vue&type=script&lang=js"
export * from "./UserSummary.vue?vue&type=script&lang=js"
import style0 from "./UserSummary.vue?vue&type=style&index=0&id=f524b542&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f524b542",
  null
  
)

export default component.exports